import {
  Fund,
  Strategy,
  ProductType,
  PaginationMeta,
  OrganisationManager,
  FundFilters,
  FundRow,
  Currency
} from '../types';
import { PensionScheme } from '@/modules/pensionScheme/types';
import { SubFund } from '@/modules/subFund/types';

export interface IFundState {
  organizationFunds: Fund[];
  organizationExposedFunds: Fund[];
  pensionSchemes: PensionScheme[];
  strategies: Strategy[];
  productTypes: ProductType[];
  paginationMeta: PaginationMeta;
  exposedPaginationMeta: PaginationMeta;
  organizationSubFunds: SubFund[];
  organizationManagers: OrganisationManager[];
  exposedFundsFilters: FundFilters | null;
  allFundsFilters: FundFilters | null;
  selectedFund: FundRow;
}

export const FundState: IFundState = {
  selectedFund: {} as FundRow,
  organizationFunds: [],
  organizationExposedFunds: [],
  pensionSchemes: [],
  strategies: [],
  productTypes: [],
  paginationMeta: {} as PaginationMeta,
  exposedPaginationMeta: {} as PaginationMeta,
  organizationSubFunds: [],
  organizationManagers: [],
  exposedFundsFilters: {
    fundIds: [],
    assetManagerIds: [],
    rootIds: [],
    rootEntityIds: [],
    rootEntities: [],
    reportingPeriodIds: [],
    statusFilter: '',
    searchKeyword: ''
  },
  allFundsFilters: {
    fundIds: [],
    assetManagerIds: [],
    rootIds: [],
    rootEntityIds: [],
    rootEntities: [],
    reportingPeriodIds: [],
    statusFilter: '',
    searchKeyword: ''
  }
};
